import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const checkInEquipmentTypesAdapter = getAdapter({ idFieldName: 'text' });

const checkInEquipmentTypesSlice = createSlice({
  name: 'checkInEquipmentTypes',
  initialState: checkInEquipmentTypesAdapter.getInitialState(),
  reducers: {
    setCheckInEquipmentTypes: (state, { payload: { checkInEquipmentTypes } }) => {
      checkInEquipmentTypesAdapter.setAll(state, checkInEquipmentTypes);
    }
  }
});

const selectors = checkInEquipmentTypesAdapter.getSelectors(({ checkInEquipmentTypes }) => checkInEquipmentTypes);

export const getCheckInEquipmentTypes = state => selectors.selectAll(state);

export const { setCheckInEquipmentTypes } = checkInEquipmentTypesSlice.actions;

export default checkInEquipmentTypesSlice.reducer;
